
export type POST<T> = {
    method: "POST";
    query?: Record<string, unknown>;
    payload: T;
    endpoint?: string
};

export type GET<Q = unknown> = {
    method: "GET";
    query?: Record<string, Q>;
    id?: string;
    endpoint?: string
};

export type UPDATE<T> = {
    method: "UPDATE";
    query?: Record<string, unknown>;
    id: string;
    payload: T;
    endpoint?: string
};

export type DELETE = {
    method: "DELETE";
    query?: Record<string, unknown>;
    id: string;
    endpoint?: string
};


export const postCall = <T>(payload: T, query: Record<string, unknown> = {}, endpoint?: string): POST<T> => ({
    method: "POST",
    payload,
    query,
    endpoint
});

export const getCall = <Q = unknown>(query: Record<string, Q> = {}, id = "", endpoint?: string): GET<Q> => ({
    method: "GET",
    query,
    id,
    endpoint

});

export const updateCall = <T>(id: string, payload: T, query: Record<string, unknown> = {}, endpoint?: string): UPDATE<T> => ({
    method: "UPDATE",
    id,
    payload,
    query,
    endpoint

});

export const deleteCall = (id: string, query: Record<string, unknown> = {}, endpoint?: string): DELETE => ({
    method: "DELETE",
    id,
    query,
    endpoint

});
